export function getVideoUrls(type: string) {
    switch (type) {
        case "create-mls-listing":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20How%20to%20Create%20a%20Listing%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/create-mls-listing.jpg",
            };

        case "create-non-mls-listing":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20How%20to%20Create%20a%20Listing%20(Non-MLS)%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/create-non-mls-listing.png",
            };
        case "create-campaign":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20Create%20a%20New%20Campaign%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/create-campaign.png",
            };
        case "create-slideshow":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20Making%20Slideshow%20Video%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/create-slideshow.png",
            };
        case "using-videos":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20Using%20Video%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/using-videos.png",
            };
        case "schedule-an-open-house":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot_%20How%20to%20Schedule%20an%20Open%20House%20-%204K.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/open-house.png",
            };
        case "create-neighborhood-expert-campaign":
            return {
                url: "https://storage.googleapis.com/marabot-main/Marabot%20-%20Create%20a%20Neighborhood%20Expert%20Campaign.mov",
                thumbnail:
                    "https://storage.googleapis.com/marabot-main/create-promotion-campaign.png",
            };
        default:
            return { url: "", thumbnail: "" };
    }
}
